/**
 * THE PLACES A LOCATION PICKER OFFERS (18 Oct 2026: «щоб ввести локацію,
 * обрати необхідну, це просто ад»).
 *
 * The tree has three levels (docs/database.md): 0 a country, 1 a region /
 * oblast, deeper a city. Each form allows some of them — the organiser, 18 Oct
 * 2026: a club, an athlete and a competition's venue are in a CITY; a ФСТ in a
 * region or a country; a competition's regional scope is regions, its
 * international scope countries.
 *
 * Every option carries the chain above it, country first, so «Київ» the city
 * and «Київ» the region are told apart, and a search matches the region and
 * country too («черкас» finds every city of Черкаська область).
 */
export const COUNTRY = 'country';
export const REGION = 'region';
export const CITY = 'city';

const idOf = iri => (iri ? String(iri).split('/').pop() : null);

export const kindOf = location => {
    const level = Number(location && location.level);
    if (0 === level) {
        return COUNTRY;
    }

    return 1 === level ? REGION : CITY;
};

/** id → location, and each one's chain of ancestors' titles, country first. */
export const indexLocations = locations => {
    const byId = {};
    (locations || []).forEach(location => {
        byId[location.id] = location;
    });
    const pathOf = location => {
        const path = [];
        const seen = new Set();
        for (let node = byId[idOf(location.parent)]; node && !seen.has(node.id); node = byId[idOf(node.parent)]) {
            seen.add(node.id);
            path.unshift(node.title);
        }

        return path;
    };

    return { byId, pathOf };
};

const option = (location, pathOf, outOfKind = false) => {
    const path = pathOf(location);

    return {
        id: location.id,
        title: location.title,
        kind: kindOf(location),
        // «Черкаська область, Україна» — nearest first, as one reads an address.
        context: [...path].reverse().join(', '),
        group: path[0] || location.title,
        sortKey: [...path, location.title].join('\u0000').toLocaleLowerCase('uk'),
        outOfKind,
    };
};

/**
 * The options of one picker: the places of the allowed kinds (and, for a
 * filter, only those in `restrictTo`), grouped by country, ordered country →
 * region → city. A current value of another kind — a club recorded on a
 * region before 18 Oct 2026 — is kept, flagged `outOfKind`, so the form still
 * shows what is stored rather than a blank.
 */
export const locationOptions = (locations, kinds, { restrictTo = null, keep = [] } = {}) => {
    const { byId, pathOf } = indexLocations(locations);
    const allowed = new Set(kinds);
    const only = restrictTo ? new Set(restrictTo) : null;
    const options = (locations || [])
        .filter(location => allowed.has(kindOf(location)) && (!only || only.has(location.id)))
        .map(location => option(location, pathOf));
    const present = new Set(options.map(o => o.id));
    keep.filter(id => id && byId[id] && !present.has(id))
        .forEach(id => options.push(option(byId[id], pathOf, true)));

    return options.sort((a, b) => a.sortKey.localeCompare(b.sortKey, 'uk'));
};

/** What a search matches: the name, the region and country above it. */
export const searchText = option => `${option.title} ${option.context}`;

/** Whether `locationId` is `ancestorId` or lies under it — a club's city within a ФСТ's region. */
export const isWithin = (locations, locationId, ancestorId) => {
    if (!locationId || !ancestorId) {
        return false;
    }
    const { byId } = indexLocations(locations);
    const seen = new Set();
    for (let node = byId[locationId]; node && !seen.has(node.id); node = byId[idOf(node.parent)]) {
        if (node.id === ancestorId) {
            return true;
        }
        seen.add(node.id);
    }

    return false;
};
